export default __webpack_public_path__ + "static/media/gsapC.97a05302.webp";